export interface NetworkCapability {
  isOnline(): boolean
  subscribe(listener: (online: boolean) => void): () => void
}

export class WebNetwork implements NetworkCapability {
  isOnline(): boolean { return navigator.onLine }
  subscribe(listener: (online: boolean) => void): () => void {
    const update = () => listener(this.isOnline())
    addEventListener('online', update)
    addEventListener('offline', update)
    return () => { removeEventListener('online', update); removeEventListener('offline', update) }
  }
}
